import React from 'react';

interface LoadingSkeletonProps {
  colSpan: number; // receives flatTableColCount from ResultsTable — NEVER hardcode 4
  rows?: number;   // default 8
}

export default function LoadingSkeleton({
  colSpan,
  rows = 8,
}: LoadingSkeletonProps): React.ReactElement {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <tr key={i} className="skeleton-row">
          <td colSpan={colSpan}>
            <span className="skeleton-cell" style={{ width: `${40 + (i % 5) * 10}%` }} />
          </td>
        </tr>
      ))}
    </>
  );
}
